import cx from 'classnames'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'

import Styles from './Frame.module.scss'
import { TabEntry, UNKNOWN_URL, useTabRoot } from './TabRootStore'

export const Frame = observer(function Frame({ tabEntry }: { tabEntry: TabEntry }) {
  const ref = useRef<HTMLIFrameElement>(null)
  const tabRoot = useTabRoot()
  const isHidden = computed(() => tabRoot.currentTab !== tabEntry).get()

  useEffect(() => {
    const iframeEl = ref.current

    if (iframeEl == null) {
      return
    }

    const onLoad = () => {
      if (iframeEl.contentDocument == null) {
        tabRoot.updateTabEntry(tabEntry, { href: UNKNOWN_URL, title: '🌐 Web Browser' })
        return
      }
    }

    iframeEl.addEventListener('load', onLoad)
    return () => iframeEl.removeEventListener('load', onLoad)
  }, [tabEntry, tabRoot])

  return (
    <iframe
      ref={ref}
      key={tabEntry.uuid}
      data-uuid={tabEntry.uuid}
      src={tabEntry.initialUrl}
      title="little kid"
      className={cx(Styles.framedContent, {
        [Styles.hiddenFrame]: isHidden,
      })}
    />
  )
})
